<mat-toolbar color="accent">
  <span>Select Clinical Notes</span>
</mat-toolbar>

<mat-dialog-content>
  <table
    class="w-full"
    mat-table
    multiTemplateDataRows
    [dataSource]="dataSource()"
  >
    <!-- Recorded Date Column -->
    <ng-container matColumnDef="recordDate">
      <th *matHeaderCellDef mat-header-cell>
        <span class="font-bold">Recorded On</span>
      </th>
      <td *matCellDef="let record" mat-cell>
        {{ record.recordDate | moment | amDateFormat: dateFormat }}
      </td>
    </ng-container>

    <!-- Recorded By Column -->
    <ng-container matColumnDef="recordedBy">
      <th *matHeaderCellDef mat-header-cell>
        <span class="font-bold">Recorded By</span>
      </th>
      <td *matCellDef="let record" mat-cell>
        {{ record.owner?.name }}
      </td>
    </ng-container>

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th *matHeaderCellDef mat-header-cell class="w-12">
        <mat-checkbox
          [checked]="selectionList.isAllSelected$ | async"
          [indeterminate]="selectionList.isSomeSelected$ | async"
          (change)="selectionList.toggleAllSelected()"
          (click)="$event.stopPropagation()"
        />
      </th>
      <td
        *matCellDef="let row"
        mat-cell
        class="w-12"
        (click)="$event.stopPropagation()"
      >
        <mat-checkbox
          [checked]="row | map: isSelected$ : this | async"
          (click)="
            this.selectionList.toggleSelected(row); $event.stopPropagation()
          "
        />
      </td>
    </ng-container>

    <!-- Expand Column -->
    <ng-container matColumnDef="expand">
      <th
        *matHeaderCellDef
        mat-header-cell
        aria-label="row actions"
        class="w-12"
      >
        <button
          mat-icon-button
          aria-label="expand all rows"
          [matTooltip]="allExpanded() ? 'Collapse All' : 'Expand All'"
          (click)="toggleAllExpanded(); $event.stopPropagation()"
        >
          <mat-icon>
            {{ allExpanded() ? 'unfold_less' : 'unfold_more' }}
          </mat-icon>
        </button>
      </th>
      <td *matCellDef="let record" mat-cell class="w-12">
        <button
          mat-icon-button
          aria-label="expand row"
          (click)="toggle(record); $event.stopPropagation()"
        >
          <mat-icon>
            {{
              isRecordExpanded()(record)
                ? 'keyboard_arrow_up'
                : 'keyboard_arrow_down'
            }}
          </mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Expanded Content Column -->
    <ng-container matColumnDef="expandedDetail">
      <td
        *matCellDef="let record"
        mat-cell
        class="bg-white p-0"
        [attr.colspan]="columnsToDisplay.length"
      >
        <div
          [ngClass]="{
            'max-h-0 opacity-0': !isRecordExpanded()(record),
            'max-h-fit opacity-100': isRecordExpanded()(record)
          }"
        >
          @if (isRecordExpanded()(record)) {
            <div class="p-4">
              <pr-content-view [content]="record.content" />
            </div>
          }
        </div>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="columnsToDisplay" mat-header-row></tr>
    <tr
      *matRowDef="let record; columns: columnsToDisplay"
      mat-row
      class="cursor-pointer hover:bg-gray-100"
      [ngClass]="{ 'expanded-row': isRecordExpanded()(record) }"
      (click)="toggle(record)"
    ></tr>
    <tr
      *matRowDef="let record; columns: ['expandedDetail']"
      class="h-0"
      mat-row
      [ngClass]="{
        hidden: !isRecordExpanded()(record),
        'content-row table-row': isRecordExpanded()(record)
      }"
    ></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button (click)="dialogRef.close(undefined)">
      Cancel
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!hasChanges()"
      (click)="dialogRef.close(selected())"
    >
      Save
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
